<template>
      <b-card class="card-challenges-post" :style="{'background-image': `url(${theMedia})`}">
        <div class="loadImg" :class="{hidden:hide}" :style="{'background-color': '#E1E5E8'}">
          <div class="img-logo">
            <img src="/img/logo-areas-B&W.png" height="100px" width="100px">
          </div>
        </div>
          
          <div class="infos">
            <h4>
              <PuSkeleton :loading="isLoading" :count="1" height="50px" width="220px">                              
                {{title}}
              </PuSkeleton>
            </h4>
            <h6>
              <PuSkeleton :loading="isLoading" :count="1" height="30px" width="100px">                                            
                {{subtitle}}
              </PuSkeleton>
            </h6>
            <p class="desc">
              <PuSkeleton :loading="isLoading" :count="1" width="60px">              
                {{desc}} ...
              </PuSkeleton>  
            </p>

            <b-button variant="outline" class="btn-outline" :to="link" @click.prevent="onItemClick">
              En savoir plus
              <span>
                <font-awesome-icon :icon="['far', 'arrow-right']"/>
              </span>
              </b-button>
          </div>
      </b-card>
</template>


<script>
import ApiService from '../../../services/ApiService'
//
export default {
  name: "CardChallengesPostCard",
  components:{ 
  },
  props:{
    subtitle:{
      type:String,
    },
    title:{
      type:String,
    },
    desc:{
      type:String,
    },
    linkTitle:{
      type:String,
    },
    link:{
      type:String,
      default:'#'
    },
    isLoad:{
      type:Boolean,
      default: true
    },    
    img:{
      default: null
    }    
  },
  data(){
    return {
      isLoading:true,
      isImageLoading: true,
      theMedia:'',
      hide:false,
    }
  },
  created(){
    this.isLoading = this.isLoad;  
    this.getData();
  },  
  methods : {
    async getData (){
      if(this.img){
        this.theMedia = await ApiService.getMediaApi().get(this.img);        
        this.hide = true;
      } else {
        this.isImageLoading = false;
      }
    }, 
    onItemClick(){
      this.isMobile ? this.$router.push({ name: 'mobile', params: { subcat: 4 }}).catch(()=>{}) : this.$router.push({ name: 'challenges-destinations'}).catch(()=>{});
    },       
  },  
  watch : {
    'isLoad' : function (){
      this.isLoading = this.isLoad;  
      this.hide = false;
      this.getData();   
    },
  },   
}
</script>
